import { Box, Flex, Icon, Image, ImageProps, Text, TextProps } from '@chakra-ui/react';
import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';

type StepCardProps = {
  icon?: string;
  iconAvatar?: boolean;
  iconProps?: ImageProps;
  label: string;
  labelProps?: TextProps;
  isCompleted: boolean;
  labelTrailing?: React.ReactNode;
  subtitle?: React.ReactNode;
  description: React.ReactNode;
  descriptionProps?: TextProps;
  belowDescription?: React.ReactNode;
  footer?: React.ReactNode;
};

const StepCard = ({
  icon,
  iconAvatar = false,
  iconProps,
  label,
  labelProps,
  isCompleted,
  labelTrailing,
  subtitle,
  description,
  descriptionProps,
  belowDescription,
  footer,
}: StepCardProps) => (
  <Box py={{ base: 4, md: 8 }} px={{ base: 10, md: 24 }}>
    <Flex align="center" gap={{ base: 4, md: 8 }}>
      <Box w="20%" boxSize={{ base: '40px', md: '50px' }}>
        {icon && (
          <Image
            src={icon}
            boxSize="full"
            objectFit="contain"
            alt=""
            transformOrigin="center"
            {...(iconAvatar && {
              borderRadius: 'full',
              border: '2px solid',
              borderColor: 'gray.200',
              objectFit: 'cover',
            })}
            {...iconProps}
          />
        )}
      </Box>
      <Box w="80%">
        <Flex align="center" gap={{ base: 2, md: 4 }}>
          {isCompleted && (
            <Icon as={FaCheckCircle} boxSize={{ base: '15px', md: '20px' }} color="successGreen" />
          )}
          <Text fontWeight="800" fontSize={{ base: 'lg', md: '2xl' }} {...labelProps}>
            {label}
          </Text>
          {labelTrailing}
        </Flex>
        {subtitle}
        <Text fontSize={{ base: 'sm', md: 'md' }} mt={0.5} lineHeight="1.4" {...descriptionProps}>
          {description}
        </Text>
        {belowDescription}
      </Box>
    </Flex>
    {footer}
  </Box>
);

export default StepCard;
